// extracted by mini-css-extract-plugin
export var heroTitle = "main-title-module--heroTitle--k_6c_";